export class SparqlTemplateError extends Error {

}
